import React from 'react';

interface AppliedFiltersProps {
  appliedFilters: { [label: string]: string[] };
  handleRemoveFilter: (label: string, value: string | null) => void;
  handleClearFilters: () => void;
}

export const AppliedFilters = (props: AppliedFiltersProps) => {
  const { appliedFilters, handleRemoveFilter, handleClearFilters } = props;
  return (
    <div className='flex flex-wrap gap-2'>
      { Object.entries(appliedFilters).map(([label, values]) => {
        const displayedValues = values.slice(0, 3); // Show first 3 values
        const hiddenCount = values.length - displayedValues.length; // Remaining count

        return (
          <div
              key={label}
              className='flex items-center bg-primary-light text-primary-main px-3 py-1 rounded-full text-sm'
          >
            <span className='font-medium'>{ label }: </span>
            { displayedValues.map((value, index) => (
              <span key={`${label}-${value}`} className='ml-1'>
                { value }
                { index < displayedValues.length - 1 && ',' }
              </span>
            )) }
            { hiddenCount > 0 && (
              <span className='ml-1 text-gray-500'>+{ hiddenCount } more</span>
            ) }
            <button
                className='ml-2 text-primary-text hover:text-primary-main'
                onClick={() => handleRemoveFilter(label, null)} // Remove all values from the key
            >
              ✕
            </button>
          </div>
        );
      }) }

      { Object.keys(appliedFilters).length > 0 && (
        <button
            className='ml-2 bg-red-100 text-alert-error px-3 py-1 rounded-full text-sm'
            onClick={handleClearFilters}
        >
          Clear All
        </button>
      ) }
    </div>
  );
};
